export const player_api_url = process.env.REACT_APP_FIREBASE_CONFIG === 'production'
    ? 'https://players-api-u7wfvp56wa-ew.a.run.app'
    : process.env.REACT_APP_FIREBASE_CONFIG === 'localhost'
        ? 'http://localhost:2022'
        : 'https://players-api-pj2r6ugwdq-ew.a.run.app';
